import { ReactElement } from "react"
import { useMeasure, useMedia } from "react-use"

import { Box } from "ui-kit/components-branded/index"
import { SafetyPopover } from "modules/Call/components/SafetyPopover"

interface Props {
    content: ReactElement
    footer: ReactElement
}

export function InfoCard({ content, footer }: Props) {
    const [ref, { width }] = useMeasure<HTMLDivElement>()
    const isOneColumn = useMedia("(max-width: 1023px)")
    return (
        <Box className="info-card is-flex is-flex-direction-column is-justify-content-space-between">
            <div>{content}</div>
            <hr className="is-hidden-tablet mgt-3 mgb-auto" />
            <div ref={ref} className="is-flex-direction-column mgt-3">
                <SafetyPopover
                    key={`force-reflow-on-container-resize-${width}`}
                    maxWidth={isOneColumn ? "100vw" : width}
                    className="link-secondary blm-button button is-like-link"
                >
                    Ваш звонок защищен
                </SafetyPopover>
                {footer}
            </div>
        </Box>
    )
}
